import React, { JSX, useEffect, useState } from 'react';
import SelectedFiltersList from './SelectedFiltersList';
import {
  LocationDefaultsType,
  LocationFilterOptionsType,
  LocationFiltersType,
  ProviderDefaultsType,
  ProviderFilterOptionsType,
  ProviderFiltersType,
  RemoveFilterType,
  UpdateQueryType,
  UpdateSortType,
} from 'components/types/FilterTypes';
import SortBy from './SortBy';
import Toggle from '../providers/filters/Toggle';

type ResultsControlsProps = {
  loading: boolean;
  count: number;
  getResultsCount: Function;
  searchType: string;
  activeFilterPanel: string;
  removeFilter: RemoveFilterType;
  removeLocationFilters: () => void;
  filters: LocationFilterOptionsType | ProviderFilterOptionsType;
  filterDefaults: LocationDefaultsType | ProviderDefaultsType;
  query: string;
  selectedFilters: LocationFiltersType | ProviderFiltersType;
  selectedFacets: any;
  selectedFacetsCount: number;
  updateQuery: UpdateQueryType;
  clearAllFilters: () => void;
  sort: string;
  updateSort: UpdateSortType;
  withOrigin: boolean;
  viewMode?: string;
  setViewMode?: Function;
};

const ResultsControls = (props: ResultsControlsProps): JSX.Element => {
  const {
    loading,
    count,
    getResultsCount,
    searchType,
    activeFilterPanel,
    removeFilter,
    removeLocationFilters,
    filters,
    filterDefaults,
    query,
    selectedFilters,
    selectedFacets,
    selectedFacetsCount,
    updateQuery,
    clearAllFilters,
    sort,
    updateSort,
    withOrigin,
    viewMode,
    setViewMode,
  } = props;

  const [resultsCount, setResultsCount] = useState(
    (<span></span>) as JSX.Element
  );

  const toggleView = () => {
    setViewMode &&
      (viewMode == 'map' ? setViewMode('list') : setViewMode('map'));
  };

  useEffect(() => {
    if (typeof window != undefined) {
      setResultsCount(getResultsCount());
    }
  }, [props]);

  const resultsHeading = searchType === 'providers' ? 'Providers' : 'Locations';

  return (
    <div
      className={
        searchType === 'locations'
          ? 'results-controls locations'
          : 'results-controls providers'
      }
    >
      <SelectedFiltersList
        activeFilterPanel={activeFilterPanel}
        removeFilter={removeFilter}
        removeLocationFilters={removeLocationFilters}
        selectedFilters={selectedFilters}
        selectedFacets={selectedFacets}
        filters={filters}
        filterDefaults={filterDefaults}
        selectedFacetsCount={selectedFacetsCount}
        query={query}
        updateQuery={updateQuery}
        searchType={searchType}
        clearAllFilters={clearAllFilters}
      />
      <div className="controls-top">
        <h2 className="screen-recording-only" tabIndex={0}>
          {resultsHeading} ({count})
        </h2>
        {searchType === 'locations' && (
          <div className="toggle-wrapper">
            <Toggle
              onChange={toggleView}
              label={'Map View'}
              labelFor={'Map View'}
              checked={viewMode === 'map'}
              extraClass={'map-toggle'}
            ></Toggle>
          </div>
        )}
        {viewMode !== 'map' && (
          <span className="results-count osf-button-label">
            {loading ? 'Loading...' : resultsCount}
          </span>
        )}
        {viewMode !== 'map' && (
          <SortBy sort={sort} updateSort={updateSort} withOrigin={withOrigin} />
        )}
      </div>
    </div>
  );
};

export default ResultsControls;
